<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Counseling Activity Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col lg="3">
          <label>Patient's Township <require-sign /></label>
                <v-select
                :items="townships"
                v-model="counselingData.patient_township_id"
                item-text="name"
                item-value="id"
                dense
                outlined
                ></v-select>
        </v-col>
        <v-col lg="3">
          <label>Code <require-sign /></label>
          <small class="text-muted">&nbsp; (eg. 99 or 2)</small>
          <v-text-field
            v-model="counselingData.mdrtb_code"
            :validationMsg="handleFieldErrors($v.counselingData.mdrtb_code)"
            hide-details
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="3">
          <label>Year <require-sign /></label>
          <small class="text-muted">&nbsp; (eg. 24)</small>
          <v-text-field
            v-model="counselingData.mdrtb_year"
            :validationMsg="handleFieldErrors($v.counselingData.mdrtb_year)"
            hide-details
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col lg="3">
          <label>Mono-Poly<require-sign /></label>
        <v-select
          v-model="counselingData.mdrtb_monopoly"
          :items="[
            { id: 1, text: 'No' },
            { id: 2, text: 'Yes' },
            { id: 3, text: 'SG' },
            { id: 4, text: 'MGY' },
          ]"
          :error="$v.counselingData.mdrtb_monopoly.$error"
          item-text="text"
          item-value="id"
          dense
          outlined
        ></v-select>
        </v-col>
        </v-row>
      <v-row>
        <v-col cols="12" lg="9">
          <v-card outlined class="outside-township-card pa-3" elevation="0">
            <div class="d-flex align-center flex-wrap">
              <div class="outside-township-label mr-3">
                <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
                Outside Township
              </div>
              <v-radio-group
                v-model="counselingData.outside_township"
                class="mt-0 flex-grow-0 outside-township-radio"
                hide-details
                dense
                row
              >
                <v-radio label="No" value="1" color="teal accent-4"></v-radio>
                <v-radio label="Yes" value="2" color="teal accent-4"></v-radio>
              </v-radio-group>
              <v-expand-transition>
                <v-select
                  v-if="showOutsideTownshipSelect"
                  :items="outside_townships"
                  v-model="counselingData.outside_township_id"
                  item-text="name"
                  item-value="id"
                  dense
                  outlined
                  clearable
                  placeholder="Choose township"
                  class="ml-lg-4 mt-2 mt-lg-0"
                  :error-messages="
                    handleFieldErrors($v.counselingData.outside_township_id)
                  "
                  style="min-width: 200px;"
                  @focus="fetchOutsideTownshipsIfNeeded({ clearOutsideId: false })"
                >
                  <template v-slot:label>
                    <span>
                      Select township
                      <require-sign v-if="showOutsideTownshipSelect" />
                    </span>
                  </template>
                </v-select>
              </v-expand-transition>
            </div>
          </v-card>
        </v-col>
      </v-row>
        <v-row>
        
        <v-col lg="4">
          
          <label>Date <require-sign /></label>
          <date-picker
            @clearDate="counselingData.date = null"
            :validationMsg="handleFieldErrors($v.counselingData.date)"
            :date="counselingData.date"
            v-model="counselingData.date"
            :min="minDate"
            :max="maxDate"
          />
        </v-col>

        <v-col md="4">
          <label>Counseling Way <require-sign /></label>
          <v-select
            :items="[
              {value:'in-person',text:'In-person'},
              {value:'by-phone',text:'By-phone'},
            ]"
            v-model="counselingData.type"
            :error-messages="handleFieldErrors($v.counselingData.type)"
            item-text="text"
            item-value="value"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col lg="4">
          <label>Topics <require-sign /></label>
          <v-select
            :items="topicsOpt"
            multiple
            v-model="computeTopicsId"
            :error-messages="handleFieldErrors($v.counselingData.topics)"
            item-text="text"
            item-value="topic_id"
            dense
            outlined
          ></v-select>
        </v-col>
      </v-row>
      <p class="subtitle-1">
        Number of household members
        <span class="red--text subtitle-2">
          ( You must fill in one field at below)</span
        >
      </p>
      <v-row>
        <v-col md="4">
          <label> {{under_5}} <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.less_than_5_count"
            :error-messages="
              handleFieldErrors($v.counselingData.less_than_5_count)
            "
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col md="4">
          <label>5yrs to 15yrs <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.between_5_and_14_count"
            :error-messages="
              handleFieldErrors($v.counselingData.between_5_and_14_count)
            "
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col md="4">
          <label>{{upper_15}} <require-sign /></label>
          <v-text-field
            v-model.trim="counselingData.greate_than_15"
            :error-messages="
              handleFieldErrors($v.counselingData.greate_than_15)
            "
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn @click.prevent="emitData" class="form-btn">
        <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, helpers } from "vuelidate/lib/validators";
import { ValidationMixin } from "../../mixins/ValidationMixin";
import { limitDateMixin } from "../../mixins/limitDateMixin";
import { mapState,mapActions } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
import RequireSign from "@/components/notification/RequireSign.vue";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { RequireSign, FormRequireNoti, DatePicker },
  mixins: [ValidationMixin, limitDateMixin],
  props: {
    counselingData: {
      type: Object,
      default: () => {
        return {
          date: null,
          type: null,
          mdrtb_code: null,
          mdrtb_year: null,
          mdrtb_monopoly:1,
          less_than_5_count: null,
          between_5_and_14_count: null,
          greate_than_15: null,
          topics: [],
          patient_township_id:null,
          outside_township: "1",
          outside_township_id: null,
        };
      },
    },
  },
  data: () => ({
    topicsOpt: [
      { topic_id: 1, text: "Treatment Adherence" },
      { topic_id: 2, text: "Psychological Support" },
      { topic_id: 3, text: "Contact Investigation" },
      { topic_id: 4, text: "Infection Control" },
      { topic_id: 5, text: "Checking Side Effect" },
      { topic_id: 6, text: "Service Directory" },
    ],
    under_5:'<5yrs',
    upper_15:'>15yrs'
  }),
  validations() {
    return {
      counselingData: {
        mdrtb_code: { required },
        mdrtb_year: { required },
        mdrtb_monopoly:{required},
        date: { required },
        type: { required },
        topics: { required },
        patient_township_id:{required},
        less_than_5_count: {
          required: this.checkHouseMemberValidation,
        },
        greate_than_15: {
          required: this.checkHouseMemberValidation,
        },
        between_5_and_14_count: {
          required: this.checkHouseMemberValidation,
        },
        outside_township_id: {
          required() {
            return this.showOutsideTownshipSelect
              ? required(this.counselingData.outside_township_id)
              : true;
          },
        },
        
      },
    };
  },
  watch: {
    "counselingData.outside_township": {
      immediate: true,
      handler(val) {
        if (val != null && val !== "") {
          this.$set(
            this.counselingData,
            "outside_township",
            String(val).trim()
          );
        }
        const yes =
          this.counselingData.outside_township === "2" || Number(val) === 2;
        const no =
          this.counselingData.outside_township === "1" || Number(val) === 1;
        if (yes) {
          this.fetchOutsideTownshipsIfNeeded({ clearOutsideId: false });
        } else if (no) {
          this.counselingData.outside_township_id = null;
        }
      },
    },
    "counselingData.patient_township_id"(val, oldVal) {
      if (oldVal === undefined || oldVal === null || oldVal === "") return;
      if (this.showOutsideTownshipSelect && val) {
        this.fetchOutsideTownshipsIfNeeded({ clearOutsideId: true });
      }
    },
    "counselingData.id"(val) {
      if (val != null && val !== "") {
        this.normalizeOutsideTownshipFromPayload();
        this.$nextTick(() =>
          this.fetchOutsideTownshipsIfNeeded({ clearOutsideId: false })
        );
      }
    },
    outside_townships(val) {
      if (!val || !val.length) return;
      if (!this.showOutsideTownshipSelect) return;
      this.$nextTick(() =>
        this.applyOutsideTownshipSelectionAfterListLoads()
      );
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Patient", ["patients"]),
    ...mapState("InfoData", [ "townships", "outside_townships"]),
    ...mapState("Admin", ["admin"]),
    computeTopicsId: {
      get() {
        return this.counselingData.topics.map((v) => {
          if(typeof v === 'object') return Number(v.topic_id)
          return Number(v.topic_id)
        });
      },
      set(val) {
        this.counselingData.topics = val.map((v) => {
          return {topic_id:v}
        })
      },
    },
    showOutsideTownshipSelect() {
      const v = this.counselingData.outside_township;
      return (
        v === "2" || v === 2 || Number(v) === 2
      );
    },
  },
  created() {
    this.getAllTownships();
    const ot = this.counselingData.outside_township;
    const normalizedOt =
      ot != null && ot !== ""
        ? String(ot).trim()
        : "1";
    this.$set(this.counselingData, "outside_township", normalizedOt);
    // Edit: apply patient.outside_tsp / township before defaulting patient_township_id to admin
    this.normalizeOutsideTownshipFromPayload();
    this.counselingData.patient_township_id =
      this.counselingData.patient_township_id == null ||
      this.counselingData.patient_township_id === ""
        ? Number(this.admin.township_id)
        : Number(this.counselingData.patient_township_id);
    this.counselingData.mdrtb_monopoly=!this.counselingData.mdrtb_monopoly?1:Number(this.counselingData.mdrtb_monopoly);
    this.fetchOutsideTownshipsIfNeeded({ clearOutsideId: false });
  },
  mounted() {
    this.fetchOutsideTownshipsIfNeeded({ clearOutsideId: false });
  },
  methods: {
    ...mapActions("InfoData", ["getAllTownships", "getOutsideTownships"]),
    normalizeOutsideTownshipFromPayload() {
      this.syncOutsideTownshipFromPatient();
      const d = this.counselingData;
      let idRaw = d.outside_township_id;
      // Counseling row may duplicate the same misnamed id column as patient.outside_tsp_name
      if (
        (idRaw == null || idRaw === "") &&
        d.outside_tsp_name != null &&
        d.outside_tsp_name !== ""
      ) {
        idRaw = d.outside_tsp_name;
      }
      const id = this.coerceOutsideTownshipRowId(idRaw);
      if (id != null) d.outside_township_id = id;
    },
    /**
     * `outside_tsp_name` is a misnamed API field: it carries the outside township row id
     * (same as item-value on the select), not a human-readable name.
     */
    coerceOutsideTownshipRowId(raw) {
      if (raw == null || raw === "") return null;
      if (typeof raw === "object" && raw.id != null) {
        const n = Number(raw.id);
        return Number.isNaN(n) ? null : n;
      }
      const n = Number(raw);
      return Number.isNaN(n) ? null : n;
    },
    /**
     * Edit: when patient.outside_tsp is 2, use patient.outside_tsp_name (id) for the select value.
     */
    syncOutsideTownshipFromPatient() {
      const d = this.counselingData;
      const p = d && d.patient;
      if (!p || typeof p !== "object") return;

      const osp = p.outside_tsp;
      const patientOutsideYes =
        osp === 2 ||
        osp === "2" ||
        Number(osp) === 2 ||
        osp === true;
      if (!patientOutsideYes) return;

      this.$set(this.counselingData, "outside_township", "2");

      const rawId =
        p.outside_tsp_name ??
        p.outside_township_id ??
        (p.outside_township && typeof p.outside_township === "object"
          ? p.outside_township.id
          : null);
      const id = this.coerceOutsideTownshipRowId(rawId);
      if (id != null) d.outside_township_id = id;

      const ptId =
        p.patient_township_id ??
        p.township_id ??
        (p.township && typeof p.township === "object" ? p.township.id : null);
      if (
        ptId != null &&
        ptId !== "" &&
        (d.patient_township_id == null || d.patient_township_id === "")
      ) {
        const n = Number(ptId);
        if (!Number.isNaN(n)) d.patient_township_id = n;
      }
    },
    /**
     * After outside_townships loads from API, set v-model to the list row id so Vuetify shows the label.
     * Handles id vs outside_tsp column and string/number mismatch with item-value.
     */
    matchOutsideTownshipSelectValue(targetId) {
      if (targetId == null || targetId === "") return null;
      const list = this.outside_townships || [];
      const n = Number(targetId);
      const row = list.find((r) => {
        const rid = r.id ?? r.outside_tsp;
        return (
          rid === targetId ||
          Number(rid) === n ||
          String(rid) === String(targetId)
        );
      });
      if (!row) return this.coerceOutsideTownshipRowId(targetId);
      const chosen = row.id != null ? row.id : row.outside_tsp;
      return chosen;
    },
    applyOutsideTownshipSelectionAfterListLoads() {
      if (!this.showOutsideTownshipSelect) return;
      this.normalizeOutsideTownshipFromPayload();
      const d = this.counselingData;
      let raw =
        d.outside_township_id ??
        d.outside_tsp_name ??
        (d.patient && d.patient.outside_tsp_name);
      const num = this.coerceOutsideTownshipRowId(raw);
      if (num == null) return;
      const matched = this.matchOutsideTownshipSelectValue(num);
      if (matched != null)
        this.$set(this.counselingData, "outside_township_id", matched);
    },
    async fetchOutsideTownshipsIfNeeded({ clearOutsideId = false } = {}) {
      if (!this.showOutsideTownshipSelect) return;
      const tid = this.counselingData.patient_township_id;
      if (!tid) return;
      if (clearOutsideId) this.counselingData.outside_township_id = null;
      try {
        await this.getOutsideTownships(tid);
      } finally {
        await this.$nextTick();
        this.applyOutsideTownshipSelectionAfterListLoads();
      }
    },
    checkHouseMemberValidation(value) {
      if (
        this.counselingData.greate_than_15 == null &&
        this.counselingData.between_5_and_14_count == null &&
        this.counselingData.less_than_5_count == null
      )
        return false;
      //? vuelidate helpers object make false to all propertries
      //? that include in current object (eg - less_than_5_count)
      return !helpers.req(value) || true;
    },
    emitData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        const topics = this.counselingData.topics.map((v) => {
          if(typeof v === 'object') return v.topic_id
          return v
        })
       
        let data = {
          id: this.counselingData.id,
          date: this.counselingData.date,
          type: this.counselingData.type,
          less_than_5_count: this.counselingData.less_than_5_count,
          between_5_and_14_count: this.counselingData.between_5_and_14_count,
          greate_than_15: this.counselingData.greate_than_15,
          topics: topics,
          month: this.$route.params.month,
          year: this.$route.params.year,
          mdrtb_code: this.counselingData.mdrtb_code,
          mdrtb_year: this.counselingData.mdrtb_year,
          mdrtb_monopoly:this.counselingData.mdrtb_monopoly,
          patient_township_id:this.counselingData.patient_township_id,
          outside_township: this.counselingData.outside_township,
          ...(this.showOutsideTownshipSelect &&
            this.counselingData.outside_township_id != null && {
              outside_township_id: this.counselingData.outside_township_id,
            }),
        };
        
       // const threeDigitPattern = /^[0-9]{3}$/;
        const twoDigitPattern = /^.*[0-9]{2}$/;
        if (
          this.counselingData.mdrtb_code && this.counselingData.mdrtb_monopoly &&
          twoDigitPattern.test(this.counselingData.mdrtb_year)
        ) {
          this.$emit("emitData", data);
        } else { 
          // if (!threeDigitPattern.test(this.counselingData.mdrtb_code))
          //   this.$toast.error(
          //     "code must has at least three digit."
          //   );
          if (!twoDigitPattern.test(this.counselingData.mdrtb_year))
            this.$toast.error("year must has at least two digit.");
          this.clearToastErrors();
        }
      }
    },
  },
  beforeMount() {
    this.counselingData.date = !this.counselingData.date
      ? this.minDate
      : this.counselingData.date;
  },
};
</script>

<style scoped>
.outside-township-card {
  border-radius: 8px;
  border-color: rgba(0, 0, 0, 0.12);
  background-color: rgba(0, 150, 136, 0.04);
}

.outside-township-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}

.outside-township-radio {
  flex-shrink: 0;
}
</style>
